module.exports = __webpack_public_path__ + "img/flag-IL.b87c0cd9.png";